/* global ADV */
import fetchWithDefaults from '../CommonUtils/fetchWithDefaults';
import { showSuccess, showError } from '../CommonComponents/ToastMessenger/ToastMessengerActions';
import { MESSAGES } from '../CommonConstants';
import { ENROLLMENT_STATUS, TOASTER_DURATION } from './ExperianConstants';

export const SET_IS_FETCHING_SUBSCRIBERS = 'experian/SET_IS_FETCHING_SUBSCRIBERS';
export const SET_SUBSCRIBERS = 'experian/SET_SUBSCRIBERS';
export const SET_SUBSCRIBERS_ERRORS = 'experian/SET_SUBSCRIBERS_ERRORS';
export const SET_IS_FETCHING_REPORT = 'experian/SET_IS_FETCHING_REPORT';
export const SET_REPORT = 'experian/SET_REPORT';
export const ADD_NEW_SUBSCRIBER = 'experian/ADD_NEW_SUBSCRIBER';
export const UPDATE_REPORT = 'experian/UPDATE_REPORT';
export const REMOVE_SUBSCRIBER = 'experian/REMOVE_SUBSCRIBER';
export const REMOVE_REPORT = 'experian/REMOVE_REPORT';
export const SET_IS_ENROLL_MODAL_OPEN = 'experian/SET_IS_ENROLL_MODAL_OPEN';
export const SET_SUBSCRIBER_ENROLLING = 'experian/SET_SUBSCRIBER_ENROLLING';
export const SET_IS_CANCELLING_SUBSCRIPTION = 'experian/SET_IS_CANCELLING_SUBSCRIPTION';
export const SET_IS_ACCEPTING_TERMS = 'experian/SET_IS_ACCEPTING_TERMS';
export const SET_ACCEPTING_TERMS_ERRORS = 'experian/SET_ACCEPTING_TERMS_ERRORS';
export const SET_ENROLL_ERROR = 'experian/SET_ENROLL_ERROR';
export const SET_QUESTIONS_LOAD_ERRORS = 'experian/SET_QUESTIONS_LOAD_ERRORS';
export const SET_QUESTIONS_ERRORS = 'experian/SET_QUESTIONS_ERRORS';
export const SET_DARK_WEB_MODAL_ERRORS = 'experian/SET_DARK_WEB_MODAL_ERRORS';
export const SET_IS_FETCHING_QUESTIONS = 'experian/SET_IS_FETCHING_QUESTIONS';
export const SET_QUESTIONS_DATA = 'experian/SET_QUESTIONS_DATA';
export const RESET_QUESTIONS_DATA = 'experian/RESET_QUESTIONS_DATA';
export const SET_IS_SUBMITTING_QUESTIONS = 'experian/SET_IS_SUBMITTING_QUESTIONS';
export const SET_IS_ARCHIVING_ALERT = 'experian/SET_IS_ARCHIVING_ALERT';
export const SET_IS_UNARCHIVING_ALERT = 'experian/SET_IS_UNARCHIVING_ALERT';
export const SET_IS_FETCHING_ACTIVE_ALERTS = 'experian/SET_IS_FETCHING_ACTIVE_ALERTS';
export const SET_IS_FETCHING_MORE_ACTIVE_ALERTS = 'experian/SET_IS_FETCHING_MORE_ACTIVE_ALERTS';
export const ADD_ACTIVE_ALERTS = 'experian/ADD_ACTIVE_ALERTS';
export const ADD_MORE_ACTIVE_ALERTS = 'experian/ADD_MORE_ACTIVE_ALERTS';
export const ADD_ARCHIVED_ALERTS = 'experian/ADD_ARCHIVED_ALERTS';
export const ADD_MORE_ARCHIVED_ALERTS = 'experian/ADD_MORE_ARCHIVED_ALERTS';
export const SET_IS_FETCHING_ARCHIVED_ALERTS = 'experian/SET_IS_FETCHING_ARCHIVED_ALERTS';
export const SET_IS_FETCHING_MORE_ARCHIVED_ALERTS = 'experian/SET_IS_FETCHING_MORE_ARCHIVED_ALERTS';
export const SET_IS_FETCHING_DARK_WEB_DATA = 'experian/SET_IS_FETCHING_DARK_WEB_DATA';
export const REMOVE_BANK_ACCOUNT = 'experian/REMOVE_BANK_ACCOUNT';
export const REMOVE_CREDIT_CARD = 'experian/REMOVE_CREDIT_CARD';
export const ADD_NEW_CREDIT_CARD = 'experian/ADD_NEW_CREDIT_CARD';
export const ADD_NEW_BANK_ACCOUNT = 'experian/ADD_NEW_BANK_ACCOUNT';
export const ADD_NEW_TELEPHONE = 'experian/ADD_NEW_TELEPHONE';
export const REMOVE_TELEPHONE = 'experian/REMOVE_TELEPHONE';
export const ADD_NEW_EMAIL = 'experian/ADD_NEW_EMAIL';
export const REMOVE_EMAIL = 'experian/REMOVE_EMAIL';
export const ADD_NEW_MEDICAL_ID = 'experian/ADD_NEW_MEDICAL_ID';
export const REMOVE_MEDICAL_ID = 'experian/REMOVE_MEDICAL_ID';
export const ADD_NEW_PASSPORT_NUMBER = 'experian/ADD_NEW_PASSPORT_NUMBER';
export const REMOVE_PASSPORT_NUMBER = 'experian/REMOVE_PASSPORT_NUMBER';
export const ADD_NEW_IBAN = 'experian/ADD_NEW_IBAN';
export const REMOVE_IBAN = 'experian/REMOVE_IBAN';
export const ADD_NEW_DRIVER_LICENSE = 'experian/ADD_NEW_DRIVER_LICENSE';
export const REMOVE_DRIVER_LICENSE = 'experian/REMOVE_DRIVER_LICENSE';
export const UPDATE_ADDRESS = 'experian/UPDATE_ADDRESS';
export const SET_HAS_MORE_ACTIVE_ALERTS = 'experian/SET_HAS_MORE_ACTIVE_ALERTS';
export const SET_HAS_MORE_ARCHIVED_ALERTS = 'experian/SET_HAS_MORE_ARCHIVED_ALERTS';
export const RESET_STATE = 'experian/RESET_STATE';

export const setIsFetchingSubscribers = payload => ({
  type: SET_IS_FETCHING_SUBSCRIBERS,
  payload,
});

export const setSubscribers = payload => ({
  type: SET_SUBSCRIBERS,
  payload,
});

export const setSubscribersErrors = payload => ({
  type: SET_SUBSCRIBERS_ERRORS,
  payload,
});

export const setIsFetchingReport = payload => ({
  type: SET_IS_FETCHING_REPORT,
  payload,
});

export const setReport = (subscriberId, report) => ({
  type: SET_REPORT,
  subscriberId,
  report,
});

export const addNewSubscriber = payload => ({
  type: ADD_NEW_SUBSCRIBER,
  payload,
});

export const updateReport = (subscriberId, report) => ({
  type: UPDATE_REPORT,
  subscriberId,
  report,
});

export const setIsEnrollModalOpen = payload => ({
  type: SET_IS_ENROLL_MODAL_OPEN,
  payload,
});

export const setSubscriberEnrolling = payload => ({
  type: SET_SUBSCRIBER_ENROLLING,
  payload,
});

export const setIsCancellingSubscription = payload => ({
  type: SET_IS_CANCELLING_SUBSCRIPTION,
  payload,
});

export const setIsAcceptingTerms = payload => ({
  type: SET_IS_ACCEPTING_TERMS,
  payload,
});

export const setAcceptingTermsErrors = payload => ({
  type: SET_ACCEPTING_TERMS_ERRORS,
  payload,
});

export const setEnrollError = payload => ({
  type: SET_ENROLL_ERROR,
  payload,
});

export const setQuestionsLoadErrors = payload => ({
  type: SET_QUESTIONS_LOAD_ERRORS,
  payload,
});

export const setQuestionsErrors = payload => ({
  type: SET_QUESTIONS_ERRORS,
  payload,
});

export const setDarkWebModalErrors = payload => ({
  type: SET_DARK_WEB_MODAL_ERRORS,
  payload,
});

export const setIsFetchingQuestions = payload => ({
  type: SET_IS_FETCHING_QUESTIONS,
  payload,
});

export const setQuestionsData = payload => ({
  type: SET_QUESTIONS_DATA,
  payload,
});

export const resetQuestionsData = () => ({
  type: RESET_QUESTIONS_DATA,
});

export const setIsSubmittingQuestions = payload => ({
  type: SET_IS_SUBMITTING_QUESTIONS,
  payload,
});

export const removeReport = payload => ({
  type: REMOVE_REPORT,
  payload,
});

export const removeSubscriber = payload => ({
  type: REMOVE_SUBSCRIBER,
  payload,
});

export const setIsArchivingAlert = payload => ({
  type: SET_IS_ARCHIVING_ALERT,
  payload,
});

export const setIsUnarchivingAlert = payload => ({
  type: SET_IS_UNARCHIVING_ALERT,
  payload,
});

export const setIsFetchingActiveAlerts = payload => ({
  type: SET_IS_FETCHING_ACTIVE_ALERTS,
  payload,
});

export const setIsFetchingMoreActiveAlerts = payload => ({
  type: SET_IS_FETCHING_MORE_ACTIVE_ALERTS,
  payload,
});

export const addActiveAlerts = (subscriberId, alerts) => ({
  type: ADD_ACTIVE_ALERTS,
  subscriberId,
  alerts,
});

export const addMoreActiveAlerts = (subscriberId, alerts) => ({
  type: ADD_MORE_ACTIVE_ALERTS,
  subscriberId,
  alerts,
});

export const addArchivedAlerts = (subscriberId, alerts) => ({
  type: ADD_ARCHIVED_ALERTS,
  subscriberId,
  alerts,
});

export const addMoreArchivedAlerts = (subscriberId, alerts) => ({
  type: ADD_MORE_ARCHIVED_ALERTS,
  subscriberId,
  alerts,
});

export const setIsFetchingArchivedAlerts = payload => ({
  type: SET_IS_FETCHING_ARCHIVED_ALERTS,
  payload,
});

export const setIsFetchingMoreArchivedAlerts = payload => ({
  type: SET_IS_FETCHING_MORE_ARCHIVED_ALERTS,
  payload,
});

export const setIsFetchingDarkWebData = payload => ({
  type: SET_IS_FETCHING_DARK_WEB_DATA,
  payload,
});

export const removeBankAccount = (subscriberId, accountNumberLabel) => ({
  type: REMOVE_BANK_ACCOUNT,
  subscriberId,
  accountNumberLabel,
});

export const removeCreditCard = (subscriberId, cardLabel) => ({
  type: REMOVE_CREDIT_CARD,
  subscriberId,
  cardLabel,
});

export const addNewCreditCard = (subscriberId, creditCard) => ({
  type: ADD_NEW_CREDIT_CARD,
  subscriberId,
  creditCard,
});

export const addNewBankAccount = (subscriberId, bankAccount) => ({
  type: ADD_NEW_BANK_ACCOUNT,
  subscriberId,
  bankAccount,
});

export const addNewTelephone = (subscriberId, telephone) => ({
  type: ADD_NEW_TELEPHONE,
  subscriberId,
  telephone,
});

export const removeTelephone = (subscriberId, telephoneLabel) => ({
  type: REMOVE_TELEPHONE,
  subscriberId,
  telephoneLabel,
});

export const addNewEmail = (subscriberId, email) => ({
  type: ADD_NEW_EMAIL,
  subscriberId,
  email,
});

export const removeEmail = (subscriberId, emailLabel) => ({
  type: REMOVE_EMAIL,
  subscriberId,
  emailLabel,
});

export const addNewMedicalId = (subscriberId, medicalId) => ({
  type: ADD_NEW_MEDICAL_ID,
  subscriberId,
  medicalId,
});

export const removeMedicalId = (subscriberId, medicalIdLabel) => ({
  type: REMOVE_MEDICAL_ID,
  subscriberId,
  medicalIdLabel,
});

export const addNewPassportNumber = (subscriberId, passportNumber) => ({
  type: ADD_NEW_PASSPORT_NUMBER,
  subscriberId,
  passportNumber,
});

export const removePassportNumber = subscriberId => ({
  type: REMOVE_PASSPORT_NUMBER,
  subscriberId,
});

export const addNewIban = (subscriberId, iban) => ({
  type: ADD_NEW_IBAN,
  subscriberId,
  iban,
});

export const removeIban = (subscriberId, ibanLabel) => ({
  type: REMOVE_IBAN,
  subscriberId,
  ibanLabel,
});

export const addNewDriverLicense = (subscriberId, driverLicense) => ({
  type: ADD_NEW_DRIVER_LICENSE,
  subscriberId,
  driverLicense,
});

export const removeDriverLicense = subscriberId => ({
  type: REMOVE_DRIVER_LICENSE,
  subscriberId,
});

export const updateAddressAC = (subscriberId, address) => ({
  type: UPDATE_ADDRESS,
  subscriberId,
  address,
});

export const setHasMoreActiveAlerts = (hasMoreActiveAlerts, subscriberId) => ({
  type: SET_HAS_MORE_ACTIVE_ALERTS,
  hasMoreActiveAlerts,
  subscriberId,
});

export const setHasMoreArchivedAlerts = (hasMoreArchivedAlerts, subscriberId) => ({
  type: SET_HAS_MORE_ARCHIVED_ALERTS,
  hasMoreArchivedAlerts,
  subscriberId,
});

export const resetState = () => ({
  type: RESET_STATE,
});

// eslint-disable-next-line no-underscore-dangle
export const _fetchReportAfterVerification = (clientId, subscriberId) => async dispatch => {
  const response = await fetchWithDefaults(
    `/Consumer/CreditMonitoring?clientId=${clientId}&subscriberNumber=${subscriberId}`,
  );

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { CreditMonitoringReport },
      } = payload;

      const report = {
        ...CreditMonitoringReport,
        hasMoreActiveAlerts: CreditMonitoringReport.ActiveAlerts
          ? CreditMonitoringReport.ActiveAlerts.length > 0
          : null,
        hasMoreArchivedAlerts: CreditMonitoringReport.ArchivedAlerts
          ? CreditMonitoringReport.ArchivedAlerts.length > 0
          : null,
      };

      dispatch(updateReport(subscriberId, report));
    } else {
      throw new Error(errors[0]);
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }
};

export const getSubscribers = (clientId, subscriberId = '0') => async dispatch => {
  dispatch(setIsFetchingSubscribers(true));

  const response = await fetchWithDefaults(
    `/Consumer/CreditMonitoring/GetSubscribers?clientId=${clientId}`,
  );

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { Subscribers: subscribers },
      } = payload;

      dispatch(setSubscribers(subscribers));

      if (Array.isArray(subscribers) && subscribers.length > 0) {
        const firstSubscriber = subscribers[0].SubscriberNumber;
        await ADV.util.Router.go2('Experian', {
          clientId,
          subscriberId: subscriberId === '0' ? firstSubscriber : subscriberId,
        });
      }
    } else {
      dispatch(setSubscribersErrors(errors));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsFetchingSubscribers(false));
};

export const fetchReport = (clientId, subscriberId) => async dispatch => {
  dispatch(setIsFetchingReport(true));

  const response = await fetchWithDefaults(
    `/Consumer/CreditMonitoring?clientId=${clientId}&subscriberNumber=${subscriberId}`,
  );

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { CreditMonitoringReport },
      } = payload;

      const report = {
        ...CreditMonitoringReport,
        hasMoreActiveAlerts: CreditMonitoringReport.ActiveAlerts
          ? CreditMonitoringReport.ActiveAlerts.length > 0
          : null,
        hasMoreArchivedAlerts: CreditMonitoringReport.ArchivedAlerts
          ? CreditMonitoringReport.ArchivedAlerts.length > 0
          : null,
      };

      if (report) {
        dispatch(setReport(subscriberId, report));
      } else {
        dispatch(getSubscribers(clientId));
      }
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsFetchingReport(false));
};

export const enroll = (clientId, data) => async dispatch => {
  dispatch(setEnrollError(''));

  const body = new FormData();

  const parsedData = {
    clientId,
    SSN: data.ssn,
    DOB: data.dob,
    FirstName: data.firstName,
    LastName: data.lastName,
    Address1: data.address1,
    Address2: data.address2,
    City: data.city,
    State: data.state,
    ZipCode: data.zip,
    EmailAddress: data.email,
  };

  body.append('json', JSON.stringify(parsedData));

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/Enroll`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { Subscriber: subscriber },
      } = payload;

      const {
        EnrollmentStatus: status,
        ErrorDescription: error,
        SubscriberNumber: subscriberId,
        FirstName: firstName,
        LastName: lastName,
      } = subscriber;

      // Enroll with errors
      if (status === ENROLLMENT_STATUS.ERROR) {
        dispatch(setEnrollError(error));
      } else {
        const newSubscriber = {
          SubscriberNumber: subscriberId,
          FirstName: firstName,
          LastName: lastName,
        };
        dispatch(addNewSubscriber(newSubscriber));
        dispatch(setReport(subscriberId, { ExperianSubscriber: subscriber }));
        await ADV.util.Router.go2('Experian', {
          clientId,
          subscriberId,
        });

        // This is used to open the Terms modal automatically
        setTimeout(() => {
          // If there is a subscriber enrolling, modal should open automatically
          // during the enrollment process
          dispatch(setSubscriberEnrolling(subscriberId));
        }, 200);

        dispatch(setIsEnrollModalOpen(false));
      }
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }
};

export const acceptTermAndConditions = (clientId, subscriberId) => async dispatch => {
  dispatch(setIsAcceptingTerms(true));

  const body = new FormData();

  body.append('clientId', clientId);
  body.append('subscriberNumber', subscriberId);

  const response = await fetchWithDefaults(
    `/Consumer/CreditMonitoringUpdate/AcceptTermAndConditions`,
    {
      method: 'POST',
      body,
    },
  );

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { Subscriber: subscriber },
      } = payload;

      dispatch(updateReport(subscriberId, { ExperianSubscriber: subscriber }));
    } else {
      dispatch(setAcceptingTermsErrors(errors));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsAcceptingTerms(false));
};

export const getVerificationQuestions = (clientId, subscriberId) => async dispatch => {
  dispatch(setIsFetchingQuestions(true));
  dispatch(setQuestionsErrors([]));

  const response = await fetchWithDefaults(
    `/Consumer/CreditMonitoring/VerificationQuestions?clientId=${clientId}&subscriberNumber=${subscriberId}`,
  );

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { VerificationQuestions },
      } = payload;

      dispatch(setQuestionsData(VerificationQuestions));
    } else {
      dispatch(setQuestionsLoadErrors(errors));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsFetchingQuestions(false));
};

export const submitVerification = (clientId, subscriberId, data) => async (dispatch, getState) => {
  dispatch(setIsSubmittingQuestions(true));
  dispatch(setQuestionsErrors([]));

  const body = new FormData();

  const parsedData = {
    clientId,
    SubscriberNumber: subscriberId,
    ApplicantChallengeId: getState().experian.verificationQuestions.ApplicantChallengeId,
    VerificationAnswers: Object.keys(data).map(key => ({
      QuestionNumber: key,
      AnswerNumber: data[key],
    })),
  };

  body.append('json', JSON.stringify(parsedData));

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/SubmitVerification`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { Subscriber: subscriber, VerificationQuestions: newQuestions },
      } = payload;
      const { EnrollmentStatus: enrollmentStatus } = subscriber;

      if (newQuestions) {
        dispatch(setQuestionsData(newQuestions));
      } else if (enrollmentStatus === ENROLLMENT_STATUS.AUTHENTICATED) {
        try {
          await dispatch(_fetchReportAfterVerification(clientId, subscriberId));
        } catch (error) {
          dispatch(setQuestionsErrors([error.message]));
        }
      } else {
        dispatch(updateReport(subscriberId, { ExperianSubscriber: subscriber }));
      }
    } else {
      dispatch(setQuestionsErrors(errors));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsSubmittingQuestions(false));
};

export const cancelSubscription = (clientId, subscriberId) => async (dispatch, getState) => {
  dispatch(setIsCancellingSubscription(true));

  const body = new FormData();

  body.append('clientId', clientId);
  body.append('subscriberNumber', subscriberId);

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/CancelSubscription`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, errors } = await response.json();

    if (success) {
      dispatch(removeSubscriber(subscriberId));

      const { subscribers } = getState().experian;

      // We deleted the only subscriber
      if (subscribers.length === 0) {
        await ADV.util.Router.go2('Experian', {
          clientId,
          subscriberId: 0,
        });
      } else {
        // Route to the first subscriber
        const { SubscriberNumber: firstSubscriberId } = subscribers[0];

        await ADV.util.Router.go2('Experian', {
          clientId,
          subscriberId: firstSubscriberId,
        });
      }

      // Clean reports collection
      setTimeout(() => {
        dispatch(removeReport(subscriberId));
      }, 0);
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsCancellingSubscription(false));
};

export const getActiveAlerts = (clientId, subscriberId, lastAlertId = null) => async dispatch => {
  if (lastAlertId) {
    dispatch(setIsFetchingMoreActiveAlerts(true));
  } else {
    dispatch(setIsFetchingActiveAlerts(true));
  }

  const response = await fetchWithDefaults(
    `/Consumer/CreditMonitoring/GetActiveAlerts?clientId=${clientId}&subscriberNumber=${subscriberId}&lastAlertId=${lastAlertId}`,
  );

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { ActiveAlerts: alerts },
      } = payload;

      if (lastAlertId) {
        dispatch(addMoreActiveAlerts(subscriberId, alerts));
      } else {
        dispatch(addActiveAlerts(subscriberId, alerts));
      }

      dispatch(setHasMoreActiveAlerts(alerts.length > 0, subscriberId));
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsFetchingMoreActiveAlerts(false));
  dispatch(setIsFetchingActiveAlerts(false));
};

export const getArchivedAlerts = (clientId, subscriberId, lastAlertId = null) => async dispatch => {
  if (lastAlertId) {
    dispatch(setIsFetchingMoreArchivedAlerts(true));
  } else {
    dispatch(setIsFetchingArchivedAlerts(true));
  }

  const response = await fetchWithDefaults(
    `/Consumer/CreditMonitoring/GetArchivedAlerts?clientId=${clientId}&subscriberNumber=${subscriberId}&lastAlertId=${lastAlertId}`,
  );

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { ArchivedAlerts: archivedAlerts },
      } = payload;

      if (lastAlertId) {
        dispatch(addMoreArchivedAlerts(subscriberId, archivedAlerts));
      } else {
        dispatch(addArchivedAlerts(subscriberId, archivedAlerts));
      }

      dispatch(setHasMoreArchivedAlerts(archivedAlerts.length > 0, subscriberId));
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsFetchingMoreArchivedAlerts(false));
  dispatch(setIsFetchingArchivedAlerts(false));
};

export const archiveAlert = (clientId, subscriberId, alert) => async dispatch => {
  dispatch(setIsArchivingAlert(true));

  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      ...alert,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/ArchiveAlert`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, errors } = await response.json();

    if (success) {
      dispatch(getActiveAlerts(clientId, subscriberId));
      dispatch(getArchivedAlerts(clientId, subscriberId));
      dispatch(showSuccess('Alert was successfully archived', TOASTER_DURATION));
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsArchivingAlert(false));
};

export const unarchiveAlert = (clientId, subscriberId, alert) => async dispatch => {
  dispatch(setIsUnarchivingAlert(true));

  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      ...alert,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/UnArchiveAlert`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, errors } = await response.json();

    if (success) {
      dispatch(getActiveAlerts(clientId, subscriberId));
      dispatch(getArchivedAlerts(clientId, subscriberId));
      dispatch(showSuccess('Alert was successfully unarchived', TOASTER_DURATION));
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsUnarchivingAlert(false));
};

export const addBankAccount = (clientId, subscriberId, data) => async dispatch => {
  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      AccountType: data.accountType,
      AccountNumber: data.accountNumber,
      BankRouting: data.bankRouting || '',
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/AddBankAccount`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { BankAccountDetail: bankAccount },
      } = payload;

      dispatch(addNewBankAccount(subscriberId, bankAccount));
      dispatch(showSuccess('The new bank account is now being monitored', TOASTER_DURATION));
    } else {
      dispatch(setDarkWebModalErrors(errors));
      throw new Error();
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }
};

export const deleteBankAccount = (clientId, subscriberId, accountNumberLabel) => async dispatch => {
  dispatch(setIsFetchingDarkWebData(true));

  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      AccountNumberLabel: accountNumberLabel,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/DeleteBankAccount`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, errors } = await response.json();

    if (success) {
      dispatch(removeBankAccount(subscriberId, accountNumberLabel));
      dispatch(showSuccess('The Bank Account is no longer being monitored', TOASTER_DURATION));
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsFetchingDarkWebData(false));
};

export const addCreditCard = (clientId, subscriberId, { cardNumber }) => async dispatch => {
  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      CardNumber: cardNumber,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/AddCreditCard`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { CreditCardDetail: creditCard },
      } = payload;

      dispatch(addNewCreditCard(subscriberId, creditCard));
      dispatch(showSuccess('The new credit card is now being monitored', TOASTER_DURATION));
    } else {
      dispatch(setDarkWebModalErrors(errors));
      throw new Error();
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }
};

export const deleteCreditCard = (clientId, subscriberId, cardLabel) => async dispatch => {
  dispatch(setIsFetchingDarkWebData(true));

  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      CardLabel: cardLabel,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/DeleteCreditCard`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, errors } = await response.json();

    if (success) {
      dispatch(removeCreditCard(subscriberId, cardLabel));
      dispatch(showSuccess('The Credit Card is no longer being monitored', TOASTER_DURATION));
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsFetchingDarkWebData(false));
};

export const addTelephone = (clientId, subscriberId, { telephoneNumber }) => async dispatch => {
  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      TelephoneNumber: telephoneNumber,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/AddTelephone`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { PhoneNumberDetail: telephone },
      } = payload;

      dispatch(addNewTelephone(subscriberId, telephone));
      dispatch(showSuccess('The new telephone number is now being monitored', TOASTER_DURATION));
    } else {
      dispatch(setDarkWebModalErrors(errors));
      throw new Error();
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }
};

export const deleteTelephone = (clientId, subscriberId, telephoneLabel) => async dispatch => {
  dispatch(setIsFetchingDarkWebData(true));

  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      TelephoneLabel: telephoneLabel,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/DeleteTelephone`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, errors } = await response.json();

    if (success) {
      dispatch(removeTelephone(subscriberId, telephoneLabel));
      dispatch(showSuccess('The telephone number is no longer being monitored', TOASTER_DURATION));
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsFetchingDarkWebData(false));
};

export const addEmail = (clientId, subscriberId, { email }) => async dispatch => {
  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      EmailAddress: email,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/AddEmailAddress`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { EmailAddressDetail: emailDetail },
      } = payload;

      dispatch(addNewEmail(subscriberId, emailDetail));
      dispatch(showSuccess('The email address is now being monitored', TOASTER_DURATION));
    } else {
      dispatch(setDarkWebModalErrors(errors));
      throw new Error();
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }
};

export const deleteEmail = (clientId, subscriberId, emailLabel) => async dispatch => {
  dispatch(setIsFetchingDarkWebData(true));

  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      EmailAddressLabel: emailLabel,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/DeleteEmailAddress`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, errors } = await response.json();

    if (success) {
      dispatch(removeEmail(subscriberId, emailLabel));
      dispatch(showSuccess('The email address is no longer being monitored', TOASTER_DURATION));
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsFetchingDarkWebData(false));
};

export const addMedicalId = (clientId, subscriberId, { medicalId }) => async dispatch => {
  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      MedicalId: medicalId,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/AddMedicalId`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { MedicalDetail: medicalDetail },
      } = payload;

      dispatch(addNewMedicalId(subscriberId, medicalDetail));
      dispatch(showSuccess('The new Medical Id is now being monitored', TOASTER_DURATION));
    } else {
      dispatch(setDarkWebModalErrors(errors));
      throw new Error();
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }
};

export const deleteMedicalId = (clientId, subscriberId, medicalIdLabel) => async dispatch => {
  dispatch(setIsFetchingDarkWebData(true));

  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      MedicalIdLabel: medicalIdLabel,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/DeleteMedicalId`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, errors } = await response.json();

    if (success) {
      dispatch(removeMedicalId(subscriberId, medicalIdLabel));
      dispatch(showSuccess('The Medical Id is no longer being monitored', TOASTER_DURATION));
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsFetchingDarkWebData(false));
};

export const addIban = (clientId, subscriberId, { iban }) => async dispatch => {
  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      Iban: iban,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/AddIban`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { IbanDetail: ibanDetail },
      } = payload;

      dispatch(addNewIban(subscriberId, ibanDetail));
      dispatch(showSuccess('The new IBAN is now being monitored', TOASTER_DURATION));
    } else {
      dispatch(setDarkWebModalErrors(errors));
      throw new Error();
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }
};

export const deleteIban = (clientId, subscriberId, ibanLabel) => async dispatch => {
  dispatch(setIsFetchingDarkWebData(true));

  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      IbanLabel: ibanLabel,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/DeleteIban`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, errors } = await response.json();

    if (success) {
      dispatch(removeIban(subscriberId, ibanLabel));
      dispatch(showSuccess('The IBAN is no longer being monitored', TOASTER_DURATION));
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsFetchingDarkWebData(false));
};

export const addPassportNumber = (clientId, subscriberId, { passportNumber }) => async dispatch => {
  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      PassportNumber: passportNumber,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/AddPassportNumber`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { PassportNumber: newPassportNumber },
      } = payload;

      dispatch(addNewPassportNumber(subscriberId, newPassportNumber));
      dispatch(showSuccess('The new Passport Number is now being monitored', TOASTER_DURATION));
    } else {
      dispatch(setDarkWebModalErrors(errors));
      throw new Error();
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }
};

export const deletePassportNumber = (clientId, subscriberId, passportNumber) => async dispatch => {
  dispatch(setIsFetchingDarkWebData(true));

  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      PassportNumber: passportNumber,
    }),
  );

  const response = await fetchWithDefaults(
    `/Consumer/CreditMonitoringUpdate/DeletePassportNumber`,
    {
      method: 'POST',
      body,
    },
  );

  if (response.ok) {
    const { success, errors } = await response.json();

    if (success) {
      dispatch(removePassportNumber(subscriberId));
      dispatch(showSuccess('The Passport Number is no longer being monitored', TOASTER_DURATION));
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsFetchingDarkWebData(false));
};

export const addDriverLicense = (
  clientId,
  subscriberId,
  { driverLicenseNumber, driverLicenseState },
) => async dispatch => {
  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      DriverLicenseNumber: driverLicenseNumber,
      DriverLicenseState: driverLicenseState,
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/AddDriverLicense`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { DriverLicense: driverLicense },
      } = payload;

      dispatch(addNewDriverLicense(subscriberId, driverLicense));
      dispatch(showSuccess("The new Driver's License is now being monitored", TOASTER_DURATION));
    } else {
      dispatch(setDarkWebModalErrors(errors));
      throw new Error();
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }
};

export const deleteDriverLicense = (clientId, subscriberId) => async dispatch => {
  dispatch(setIsFetchingDarkWebData(true));

  const body = new FormData();

  body.append('clientId', clientId);
  body.append('subscriberNumber', subscriberId);

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/DeleteDriverLicense`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, errors } = await response.json();

    if (success) {
      dispatch(removeDriverLicense(subscriberId));
      dispatch(showSuccess("Your Driver's License is no longer being monitored", TOASTER_DURATION));
    } else {
      dispatch(showError(new Error(errors), TOASTER_DURATION));
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }

  dispatch(setIsFetchingDarkWebData(false));
};

export const updateAddress = (clientId, subscriberId, data) => async dispatch => {
  const body = new FormData();

  body.append(
    'json',
    JSON.stringify({
      clientId,
      SubscriberNumber: subscriberId,
      Address: {
        Address1: data.address1,
        Address2: data.address2,
        City: data.city,
        State: data.state,
        ZipCode: data.zip,
        CountryCode: 'US',
      },
    }),
  );

  const response = await fetchWithDefaults(`/Consumer/CreditMonitoringUpdate/UpdateAddress`, {
    method: 'POST',
    body,
  });

  if (response.ok) {
    const { success, payload, errors } = await response.json();

    if (success) {
      const {
        viewData: { Address: address },
      } = payload;

      dispatch(updateAddressAC(subscriberId, address));
      dispatch(showSuccess('The address was successfully updated', TOASTER_DURATION));
    } else {
      dispatch(setDarkWebModalErrors(errors));
      throw new Error();
    }
  } else {
    dispatch(showError(new Error(MESSAGES.GENERIC_ERROR), TOASTER_DURATION));
  }
};
